export default {
  title: "dark",

  colors: {
    primary: "#333",
    secundary: "#191622",

    background: "#222",
    text: "#fff"
  }
};
